import axios from 'axios';
import { NotesForm } from "kx-common-components";
import React from 'react';
import { connect } from "react-redux";
import { Loader } from 'semantic-ui-react';
import * as actionCreators from "../actions";
import { getShipmentNotes } from '../api/getNLForm';

 class NotesTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    }
  }

  componentDidMount(){

    
   this.createNotes()
  }

  componentDidUpdate(prevProps) {
    if (this.props.shipId !== prevProps.shipId) {
      this.createNotes()
    }
 
}



  createNotes(){
    let {initializeShipmentNotes , shipId , dontShowNotes} = this.props
    console.log(window.shipmentId,"shipId")
    axios
    .all([
    
      getShipmentNotes(window.shipmentId).catch(err => console.log(err))
    ])
    .then(
      axios.spread(function (
        notesResponse
      ) {


       initializeShipmentNotes(notesResponse.data.eventMessage , true)


      })).catch((error) => {
    console.log(error, "error")
    dontShowNotes(false)

  })
  }
    render() {
        let {createNotesItem , updateNotesItem  , saveNotesItem ,shipmentNotesNodes ,notesLoaded , fullName } = this.props
        if (notesLoaded === true) {
        return (
            <div>
            <NotesForm createNotesItem={createNotesItem} fullName={fullName}
            updateNotesItem={updateNotesItem}
            saveNotesItem={saveNotesItem}
            shipmentNotesNodes={shipmentNotesNodes}
            country={"UK"}
            />
                
            </div>
        )
    }
    else if (notesLoaded === false) {
        return (
          <center style={{ position: 'relative', top: '50vh' }}>
          {`An Error Occured In Loading Notes`}
          <i className="frown outline icon"></i>
        </center>
        )
      } else {
      return (
        <center style={{ position: 'relative', top: '30vh' }}>
          Preparing Notes{' '}
          <Loader indeterminate active inline size='small' />
        </center>
      )
    }
}
}


const mapStateToProps = (state, ownProps) => ({
  shipmentNotesNodes: state.NotesReducer.shipmentNotesNodes,
  notesLoaded: state.NotesReducer.notesLoaded,
  });
  const mapDispatchToProps = {
    ...actionCreators,
 
  };
  export default connect(mapStateToProps, mapDispatchToProps)(NotesTab);